module.exports = __webpack_public_path__ + "static/media/subscriber_Governments.981669e2.svg";